import $, { css, get } from "jquery";
$(function () {
  const $menu = $('.menu');
  const $menuSection = $menu.find('.menu-section');
  const $menuChildren = $menu.find('.menu-section .menu-item-has-children');
  const $menuArrow = $menu.find('.menu-mobile-arrow');
  const $menuClosed = $menu.find('.menu-mobile-close');
  const $menuToggle = $('.menu-mobile-toggle');
  const $menuToggleSpan = $menuToggle.find('span');
  const $menuOverlay = $('.overlay');
  let $subMenu;

  function toggleMenu() {
    $menu.toggleClass('active');
    $menuOverlay.toggleClass('active');
    $menuToggle.toggleClass('active-humburger');
    $menuToggleSpan.toggleClass('active');
    $('body').toggleClass('menu-open');
  }

  // function showSubMenu($hasChildren) {
  //   $subMenu = $hasChildren.find('.menu-subs');
  //   // $subMenu.removeClass('slide-right').addClass('active slide-left');

  //   // const menuTitle = $hasChildren.find('.main-link').text().trim();
  //   // if (menuTitle == 'Motion SimulatorsRacing SimulatorsFlight Simulators') {
  //   //   $menu.find('.menu-mobile-title').html('Motion Simulators');
  //   // }
  //   // else {
  //   //   $menu.find('.menu-mobile-title').html(menuTitle);
  //   // }

  //   // var submenu = $(this).next('.menu-subs'); // Find the submenu
  //   $subMenu.slideToggle();
  //   // // $menu.find('.menu-mobile-title').html(menuTitle);
  //   // $menu.find('.menu-mobile-header').addClass('active');
  //   // $menu.find('.menu-section').addClass('menu-section-sub');
  // }

  function hideSubMenu() {
    $subMenu.removeClass('slide-left').addClass('slide-right');
    setTimeout(function () {
      $subMenu.removeClass('active');
    }, 300);
    // $menu.find('.menu-mobile-title').html('');
    $menu.find('.menu-mobile-header').removeClass('active');
    $menu.find('.menu-section').removeClass('menu-section-sub');
  }

  function addFunctionality() {
    // $('.menu-item-has-children').on('click', function (e) {
    //   e.stopPropagation();
    //   const $this = $(this);
    //   const target = $this.data('target');
    //   $('.menu-subs').removeClass('open-menu').parent().removeClass('active');
    //   $('#' + target).addClass('open-menu').parent().addClass('active');
    // });

    $(document).on('click', function () {
      if (!$('body').hasClass('popup-open')) {
        $('.menu-subs').removeClass('open-menu').parent().removeClass('active');
      }
    });

    $menuChildren.on('click', function (e) {
      if (!$menu.hasClass('active')) {
        return;
      }

      const $this = $(this);
      const $subMenu = $this.find('.menu-subs');

      if ($subMenu.length) {
        console.log('Submenu found.'); // Check if the submenu is found
        $subMenu.slideToggle(500);
    } else {
        console.log('Submenu not found.'); // Check if the submenu is not found
    }
    });
  }

  function handleSubMenuClick(e) {
    e.stopPropagation();
    $('.menu-subs').removeClass('open-menu');
  }

  // // $('.open-menu .menu-item-has-children .menu-item-container').on('click', function (e) {
  //   $(document.body).on('click', '.open-menu .menu-item-has-children > a', function (e){
  //   e.preventDefault(); 
  //   console.log('test');
  //   var arrow = $(this).find('.sub-menu-arrow').toggleClass("rtoate180");    
  //   // $("#navigation").stop().slideToggle(500);
  //   // if (arrow.css('transform') === 'matrix(6.12323e-17, -1, 1, 6.12323e-17, 0, 0)') {
     
  //   // } else {
  //   //   arrow.css('transform', 'rotate(0deg)');
  //   // }
  //   // var submenu = $(this).next('.menu-subs'); // Find the submenu
  //   // submenu.slideToggle(); // Toggle the submenu's visibility
  // });
  addFunctionality();
  $menuArrow.on('click', hideSubMenu);
  $menuToggle.on('click', toggleMenu);
  $menuClosed.on('click', toggleMenu);
  $menuOverlay.on('click', toggleMenu);
  // $('.sims-games-menu-link').on('click', handleSubMenuClick);

  // $(window).on('resize', function () {
  //   const width = $(this).width();
  //   if (width <= 768) {
  //     addFunctionality();
  //   } else {
  //     $('.menu-item-has-children').off('click');
  //     $(document).off('click');
  //     $('.close-menu').off('click');
  //   }
  // });

  // Check screen width on initial page load
  // if ($(window).width() <= 768) {
  //   addFunctionality();
  // }
});
